import React, { useEffect, useState } from "react";
// project import
import PaginationOne from "../pagination/PaginationOne";
import { COURSES } from "../../constants/entityType";
import { slugify } from "../../utils";
import Image from "../../common/footer/Images/Image";
// third-party import
import { Link } from "react-router-dom";
function StatsTwo({ data, filters }) {
  // State variable initialization
  const [initialPage, setInitialPage] = useState(0);
  const [currentItems, setCurrentItems] = useState([]);

  //const variables
  const itemsPerPage = 10;
  const pageCount = Math?.ceil(data?.length / itemsPerPage);

  //filters
  const { filterByStats, filterByName, filterByDuration } = filters;
  const entityType =
    filterByName && filterByName.value && filterByName?.value
      ? filterByName?.value.toLowerCase()
      : COURSES;
  const url = entityType && entityType === COURSES ? "course" : "blog";

  // Constant functions
  const handlePageClick = (event) => {
    try {
      const newOffset = (event.selected * itemsPerPage) % data.length;
      window.scrollTo({ top: 0, behavior: "smooth" });
      handlePageGeneration(newOffset);
      setInitialPage(pageCount);
    } catch (error) {
      console.log("34 : StatsTwo : Error while changing page", error.message);
      throw error;
    }
  };

  // function handlePageGeneration
  const handlePageGeneration = (itemOffset) => {
    try {
      const endOffset = itemOffset + itemsPerPage;
      const newItems =
        data &&
        data.length &&
        (data.slice(itemOffset, endOffset).slice(0, itemsPerPage) || []);
      setCurrentItems(newItems);
    } catch (error) {
      console.log(
        "49 : StatsTwo : Error while generating page: ",
        error.message
      );
      throw error;
    }
  };

  //react-hook
  useEffect(() => {
    // Reset pagination to the first page
    setInitialPage(0);
    handlePageGeneration(0);
  }, [itemsPerPage, data]);

  return (
    <div>
      {(currentItems || [])?.map((item, i) => (
        <>
          <div className="row align-items-center  p-0 my-2" key={i}>
            {/* Image */}
            <div className="col-4 col-sm-3 col-md-3 col-lg-3 list-avatar p-0 d-flex align-items-center justify-content-center avatar-image position-relative w-100 ratio ratio-16x9 rounded-circle">
              <Image src={item?.image || ""} alt="featured" fill />
            </div>
            {/* Title & Categories*/}
            <div className="col-8 col-sm-7 col-md-7 col-lg-7 text-break py-2 d-flex flex-column justify-content-center">
              <Link
                to={
                  process.env.PUBLIC_URL +
                  `/${url}-details/${slugify(item?.title)}`
                }
              >
                <span className="fw-bold">{item?.title || "Untitled"}</span>
              </Link>
              <div>
                {item?.categories &&
                  item.categories.length > 0 &&
                  (item.categories || [])?.map((a) => (
                    <span className="fs-5 badge text-dark rounded-pill bg-primary bg-opacity-25 text-capitalize mx-1">
                      {a}
                    </span>
                  ))}
              </div>
            </div>
            {/* newlyAddedCounts */}
            <div className=" col-12 col-sm-2 col-md-2 col-lg-2 text-break text-start py-2">
              {entityType === COURSES ? (
                <span>
                  {item?.quizzes || "0"}
                  {" chapters"}
                </span>
              ) : (
                <span>{item?.readingTime || "0"}</span>
              )}
            </div>
          </div>
        </>
      ))}
      {/* Pagination */}
      <div className="row">
        <div className="col-lg-12 my-5 p-0 d-flex align-items-center justify-content-center">
          {data?.length > itemsPerPage && (
            <PaginationOne
              items={data || []}
              itemsPerPage={itemsPerPage}
              pageCount={pageCount}
              initialPage={initialPage}
              onCurrentItemsChange={handlePageClick}
            />
          )}
        </div>
      </div>
    </div>
  );
}
export default StatsTwo;
